@import "../../global/normalize.css";

/**
 * @prop --ic-z-index-page-header: z-index of page-header
 */

:host {
  display: block;
  z-index: var(--ic-z-index-page-header);
}

:host(.ic-page-header-sticky) {
  position: sticky;
  top: 0;
  box-shadow: var(--ic-elevation-overlay);
  z-index: var(--ic-z-index-sticky-page-header);
}

header {
  background-color: var(--ic-page-header-background);
}

header.border-bottom {
  border-bottom: var(--ic-border-default);
  border-bottom: var(--ic-space-1px) solid var(--ic-page-header-border);
}

header.tabs {
  padding-top: var(--ic-space-md);
}

.breadcrumb-area {
  margin-bottom: var(--ic-space-md);
}

::slotted(ic-navigation-item) {
  --navigation-link-colour: var(--ic-color-text-primary);
}

.main-content {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas:
    "title-area action-area"
    "input-area action-area";
  column-gap: var(--ic-space-md);
  justify-content: space-between;
  width: 100%;
}

.title-area {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 19rem;
  grid-area: title-area;
}

.header-content {
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  column-gap: var(--ic-space-md);
}

.heading {
  display: inline-block;
  overflow-wrap: break-word;
  hyphens: auto;
}

.subheading-content {
  margin-top: var(--ic-space-xs);
}

.subheading-content.small {
  margin-top: var(--ic-space-md);
}

.action-area {
  display: flex;
  gap: var(--ic-space-md);
  flex-flow: row wrap;
  justify-self: end;
  justify-content: flex-end;
  height: fit-content;
  grid-area: action-area;
}

.input-area,
.navigation-area {
  margin-top: var(--ic-space-md);
  width: 100%;
}

.tabs-slot {
  display: flex;
  overflow-x: auto;
  padding: 0.5rem;
  margin: -0.5rem;
}

.tabs-slot::-webkit-scrollbar {
  display: none;
}

.input-area {
  grid-area: input-area;
}

@media screen and (max-width: 576px) {
  ::slotted(ic-text-field) {
    --input-width: 100%;

    max-width: 20rem;
  }

  .main-content {
    grid-template-areas:
      "title-area"
      "action-area"
      "input-area";
    justify-content: flex-start;
  }

  .title-area {
    min-width: 0;
  }

  .action-area {
    min-width: 100%;
    margin-top: var(--ic-space-md);
    justify-content: start;
  }
}

@media screen and (min-width: 992px) {
  :host(.ic-page-header-sticky-desktop) {
    position: sticky;
    top: 0;
    box-shadow: var(--ic-elevation-overlay);
    z-index: var(--ic-z-index-sticky-page-header);
  }
}
